//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { ArrowLeftOutlined, ArrowRightOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Assignment, Extension, WatchLater } from '@mui/icons-material';
//  -- Components ---------------------
import { Col, Popover, Row } from 'antd';
import { find, get, map } from 'lodash';
import moment from 'moment';
import { lighten } from 'polished';
import React, { useEffect, useMemo, useState } from 'react';
import { Birdimg, GradCalendar } from 'utils/assets/images';
//  -- Thunks -------------------------
import styled from 'styled-components';
//  -- Constants ----------------------
import "moment-timezone";
import { useDispatch } from 'react-redux';
import { useCurrentClass, useCurrentClassBook } from 'store/classes/selectors';
import {  useOrgTimezone } from 'store/organizations/selectors';
import { useResources, useVideos } from 'store/resources/selectors';
import { useServertime } from 'store/servertime/selectors';
import { handleGetStudentUserPreference } from 'store/userPreference/thunks';
import COLOR from 'utils/constants/color';
import { getBookDisplayName , getExceptionStatus, getUserAssignment, imageFetch, imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';
import { isBeforTime } from "utils/methods/math";
import PopoverContent from 'components/UI/PopoverConf/Popover';
import useMobileDeviceDetection from 'containers/chat/hooks';
import { useUserAllowedBooks } from 'store/books/selectors';
import { getCoverForAssignment } from 'utils/methods/functions';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import AssignmentImgModal from './AssignmentImgModal';
import SentryWrap from 'components/Sentry';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const AssignmentContainer = styled.div`
    border: 1px solid #F4F5F7;
    height: 100%;
    min-height: 160px;
    padding 8px 4px;
`;

const Container = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 16px;
`;


const CalendarDay = styled.div`
    background-color:${p => p.isToday ? COLOR.orange100 : "#5f4c82"};
    border:3px solid #c5a1cf;
    border-radius: 15px;
    padding: 10px;
    position: relative;
    flex: 1;
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 124px;
    min-height: 180px;
    &:last-child {
        margin-right: 0px;
    }
    @media screen and (max-width: 992px) {
        min-width: 150px;
    }
    @media screen and (min-width: 360px) and (max-width: 420px) {
        min-width: 160px;
    }
    @media screen and (min-width: 522px) and (max-width: 580px) {
        min-width: 165px;
    }
    @media screen and (min-width: 680px) and (max-width: 690px) {
        min-width: 165px;
    }
    @media screen and (min-width: 690px) and (max-width: 730px) {
        min-width: 165px;
    }
    @media screen and (min-width: 846px) and (max-width: 930px) {
        min-width: 165px;
    }
    @media screen and (min-width: 992px) and (max-width: 1260px) {
        min-width: 165px;
    }
`;
const HeaderRow = styled.div`
    flex-direction: row;
    display: flex;
`
// const CalendarIcon = styled.div`
//     flex: 1;
//     background-image: url(${Calendarimg});
//     background-repeat: no-repeat;
//     background-size: 200% 200%;
//     height: 20px;
//     background-position: center;
// `
const GradCalendarSec = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;
`
const Birtdimg = styled.img`
    height: 180px;
    width: 220px;
    position: absolute;
    top: -77px;
    left: -110px;
    z-index: 1;
    background-color: transparent;
    user-select: none;
      @media screen and (max-width: 600px) {
       left:-100px;
    }
`
const DayTxt = styled.div`
    flex: 6;
    color: white;
    font-size: 20px;`
const ControlRow = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const CustomRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

const Date = styled.span`
    color:#fff;
    display: block;
    font-size: 11px;
    line-height: 10px;
    margin-bottom: 6px;
`;



const Header = styled.span`
    color: ${COLOR.black600};
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
`;

const HeaderBold = styled(Header)`
    color: ${COLOR.black100};
`;

const Item = styled.div`
    align-items: center;
    background-color: ${p => p.deactivated ? COLOR.redishpink : p.disabled ? COLOR.green900 : (p.past ? lighten(0.4, 'red') : COLOR.white)};
    border: 1px dashed ${p => (p.deactivated || p.disabled || p.past) ? COLOR.white : COLOR.black700};
    border-radius: 2px;
    color: ${p => (p.deactivated || p.disabled) ? COLOR.white : COLOR.black200};
    // cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
    display: flex;
    flex-direction: row;
    font-size: 13px;
    line-height: 15px;
    margin-bottom: 4px;
    position: relative;
    text-transform: capitalize;
    transition: all 450ms ease;
    width: 100%;

    @media (min-width: 1000px) {
        &:hover {
            background-color: ${p => !p.past && '#f9f9f9'};
            color: ${p => !p.past && COLOR.green};
            box-shadow: ${p => !p.past && '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'};
        }
    }
`

const Wrapper = styled.div`
    width: 100%;
`;

const ItemTab = styled.button`
    height:100%;
    width:80%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    // cursor: pointer;
`;
const ItemTab2 = styled.button`
    height:100%;
    width:10%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    // cursor: pointer;
`;

const ImageModal = styled.div`
    left: 50%;
    max-width: 450px;
    padding: 0px 24px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
`;
const ModalDescription = styled.div`
    background: #E7E8EA;
    display: flex;
    padding: 5px;
    flex-direction: column;
    position:relative;
`;
const ModelDescRow = styled.div`
  font-size:12px;
  text-align: center;
  font-weight: bold;
`;
const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: absolute;
    top: -5px;
    right: -5px;
    color: white;
    z-index: 1;
`;
const AssignmentNameText = styled.span`
    display: block;
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  ParentCalenar
//
//  -- Description
//  ParentCalenar of events for quick view
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const ParentCalenar = ({
    assignments,
    submissions,
    booksAllList,
    userBooks,
    currentUser,
    userPreference
}) => {
    const dispatch = useDispatch();
    const servertime = useServertime()
    const timezone = useOrgTimezone()
    const [modalOpen, setModalState] = useState(false);
    const [activeAssignment, setActiveAssignment] = useState(null)
    const currentClass = useCurrentClass()
    const userAllowedBooks = useUserAllowedBooks()
    const allowed_books = useCurrentClassBook();
    const { activeStudentParent } = useActiveStudentofParent();
    const userAssignment = useMemo(()=>getUserAssignment(allowed_books, assignments, currentUser, currentClass,userAllowedBooks?.other_permissions?.resourses, activeStudentParent),[allowed_books, assignments, currentUser, currentClass,userAllowedBooks, activeStudentParent])
    const resources = useResources()
    const videos = useVideos()
    const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [selectedDay, setSelectedDay] = useState(moment());
    const weekStart = selectedDay.clone().startOf('isoWeek');
    const deviceType = useMobileDeviceDetection();

    useEffect(() => {
        getTeacherPref();
    }, [currentClass])

    const getTeacherPref = async () => {
        if(currentUser?.role !== 'parent'){
            await dispatch(handleGetStudentUserPreference(currentClass?.teacherId, currentUser?.id));
        }
        //await dispatch(handleGetStudentUserPreference(currentClass?.teacherId, currentClass?.id));
        // setDueDatePref(getDuePref)
    }

    const generateDays = () => {
        const days = [];

        for (let i = 0; i <= 6; i++) {
            days.push(moment(weekStart).add(i, 'days'))
        }

        return days;
    };

    const WEEK = generateDays();

    const viewInfo = (x) => {
        setActiveAssignment(x)
        setModalState(true)
    }
    const closeViewinfo = () => {
        setModalState(false)
        setActiveAssignment(null)
    }
    const pageCover = usePageCover({ assignmentData: activeAssignment?.data });

    const is_soy_story = useMemo(() => activeAssignment && ((typeof activeAssignment.storyInstruction == "string" && activeAssignment.storyInstruction.length > 0) || (activeAssignment?.data && typeof activeAssignment?.data.storyInstruction == "string" && activeAssignment?.data.storyInstruction.length > 0)), [activeAssignment])
    const displayName =  get(activeAssignment, 'displayName', get(activeAssignment, 'data.displayName', ''));

    const modalSrc = () => {
        if(pageCover){
            return pageCover;
        }
        const chapter_id = get(activeAssignment, "data.chapter") || get(activeAssignment, "assignment.chapter")
        const page_id = get(activeAssignment, "data.page") || get(activeAssignment, "assignment.page")
        const cover_img_ext = getCoverForAssignment(activeAssignment)
        if (cover_img_ext) return cover_img_ext;
        return isVideo(page_id, resources) ? imageFetchFromPodcast(page_id, resources) : imageFetch(booksAllList, chapter_id, page_id)
    }
    return (
    <SentryWrap>
        <Wrapper>
            {/* <Modal
                open={modalOpen}
                onClose={closeViewinfo}
                style={{ height: '100%', width: '100%' }}
            >
                <ImageModal>
                    <ModalDescription>
                        <CloseBtn onClick={closeViewinfo}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 12 }} />
                        </CloseBtn>
                        <ModelDescRow>{getBookDisplayName(booksAllList, get(activeAssignment, "data.chapter"), true, videos, resources)}</ModelDescRow>
                    </ModalDescription>

                    <Img
                        style={{ height: "auto", width: "100%", border: `1px solid ${COLOR.black800}` }}
                        src={modalSrc()}
                        loader={<Loading />}
                    />
                    {is_soy_story && (
                        <label className='storyTitleCstm'>{activeAssignment && displayName}</label>
                    )}
                </ImageModal>
            </Modal> */}

            <AssignmentImgModal
              modalOpen={modalOpen}
              setModalOpen={closeViewinfo}
              page_src={modalSrc()}
              title={is_soy_story ? displayName : ""}
              className="max-w-581px"
              description={getBookDisplayName(booksAllList, get(activeAssignment, "data.chapter"), true, videos, resources)}
            />
            <Row gutter={[0, 16]}>
                <Col span={24}>
                    <ControlRow>
                        <Header style={{ marginLeft: 30 }}>Week <HeaderBold>{WEEK[0].format('D MMMM')} - {WEEK[6].format('D MMMM')}</HeaderBold></Header>
                        <CustomRow>
                            <ArrowLeftOutlined
                                onClick={() => setSelectedDay(moment(selectedDay).subtract(7, 'days'))}
                                style={{ color: COLOR.black500, cursor: 'pointer', marginLeft: '16px' }}
                            />
                            <ArrowRightOutlined
                                onClick={() => setSelectedDay(moment(selectedDay).add(7, 'days'))}
                                style={{ color: COLOR.black500, cursor: 'pointer', marginLeft: '8px' }}
                            />
                        </CustomRow>
                    </ControlRow>
                </Col>
            </Row>
            <div style={{ position: 'relative' }}>
                <Birtdimg src={Birdimg} />
                <Container className='CalforIpad' style={{ marginTop: 16, flexDirection: deviceType ? 'column' : 'row' }}>
                {WEEK.map((day, i) => {
                    return (
                        <CalendarDay isToday={moment().isSame(day, 'day')} key={day.unix()} style={{ width: deviceType ? '100%' : 'unset' }}>
                            {/* {i == 0 ? <Birtdimg src={Birdimg} /> : null} */}
                            <GradCalendarSec>
                                <Date>{day.format('D MMMM')}</Date>
                                <img src={GradCalendar} style={{width:"20px"}}/>
                            </GradCalendarSec>
                            <HeaderRow>
                                <DayTxt>{DAYS[day.day()]}</DayTxt>
                                {/* <CalendarIcon></CalendarIcon> */}
                            </HeaderRow>
                            <AssignmentContainer style={{ paddingLeft: 0, paddingRight: 0, borderWidth: 0, minHeight: 0 }}>
                                {map(userAssignment, x => {
                                    const submission = find(submissions, ['assignmentId', x.data?.id]);
                                    const { isException, exceptionStatusText } = getExceptionStatus(submission, currentUser)
                                    const hasTooltip = !isNaN(parseInt(x.timeDuration)) && parseInt(x.timeDuration) > 0
                                    const isActive = get(x, "active", true)
                                    let isBeforeLateDate = true
                                    let retakeAvailable = submission ? parseInt(submission?.submissions, 10) < (parseInt(x?.retakes, 10) + 1) : true;
                                    const displayName = get(x, 'displayName', get(x, 'data.displayName', ''));
                                    const dueDate = userPreference?.order_by_date === 'start_date' ? x.scheduleAt : userPreference?.order_by_date === 'late_submission' ? x.lateDate || x.dueDate : x.dueDate;
                                    if (x?.lateDate == "always") {
                                        isBeforeLateDate = false
                                    } else {
                                        isBeforeLateDate = typeof x?.lateDate == "undefined" || !x?.lateDate ? true : isBeforTime(x?.lateDate, servertime, timezone);
                                    }
                                    if (moment(dueDate).format('MDYY') === day.format('MDYY')) {
                                        const isPast = isBeforTime(dueDate, servertime, timezone)
                                        if (isPast && isBeforeLateDate) {
                                            return (
                                                // <TootipWrapper label={!isActive ? "Assignment is deactivated by teacher" : get(x, "displayName", get(x, "data.displayName", ""))} hasToolTip key={x.id}>
                                                <Popover placement="rightTop" content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />} title="Assignment Info" trigger="hover">
                                                    <Item key={x.id} past onClick={e => e.preventDefault()}>
                                                        <ItemTab>
                                                            {x?.assignment?.type === 'activity'
                                                                ? <Extension style={{ height: '18px', marginRight: '4px' }} />
                                                                : <Assignment style={{ height: '18px', marginRight: '4px' }} />
                                                            }
                                                            <AssignmentNameText>
                                                                {/* {getAssignmentLable(x,booksAllList,videos,resources)} */}
                                                                {displayName}
                                                            </AssignmentNameText>
                                                            <br />
                                                            {!isActive ? "(Deactivated)" : null}
                                                        </ItemTab>
                                                        <ItemTab2 onClick={() => viewInfo(x)}>
                                                            <InfoCircleFilled />
                                                        </ItemTab2>
                                                    </Item>
                                                </Popover>
                                            );
                                        } else {
                                            return (
                                                // <TootipWrapper hasToolTip label={!isActive ? "Assignment is deactivated by teacher" : (hasTooltip && !(get(submission, "complete", false) && !retakeAvailable)) ? "This activity includes a timer, are you sure you want to start it?" : isException ? `Assignment is marked as ${exceptionStatusText}` : get(x, "displayName", get(x, "data.displayName", ""))} key={x.id}>
                                                <Popover placement="rightTop" content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />} title="Assignment Info" trigger="hover">
                                                    <Item
                                                        past={isException}
                                                        disabled={(submission?.complete && !retakeAvailable) || isException}
                                                        deactivated={!isActive} >
                                                        <ItemTab
                                                            disabled={(submission?.complete && !retakeAvailable) || isException}
                                                            deactivated={!isActive}
                                                        >
                                                            {x?.data?.typeId === 'activity'
                                                                ? <Extension style={{ height: '18px', marginRight: '4px' }} />
                                                                : <Assignment style={{ height: '18px', marginRight: '4px' }} />
                                                            }
                                                            <AssignmentNameText>
                                                                {/* {getAssignmentLable(x, booksAllList, videos, resources)} */}
                                                                {displayName}
                                                            </AssignmentNameText>
                                                            {!isActive ? "(Deactivated)" : (submission?.complete && retakeAvailable ? 'Retake' : (isException ? exceptionStatusText : (submission?.complete ? 'Completed' : (submission ? 'Resume' : 'Due'))))}

                                                            {hasTooltip &&
                                                                <WatchLater style={{ height: '18px', marginLeft: '4px', marginTop: '4px' }} />
                                                            }
                                                        </ItemTab>
                                                        <ItemTab2 onClick={() => viewInfo(x)}>
                                                            <InfoCircleFilled />
                                                        </ItemTab2>
                                                    </Item>
                                                </Popover>
                                            );
                                        }
                                    }
                                })}
                            </AssignmentContainer>
                        </CalendarDay>
                    )
                })}
                </Container>
                </div>
        </Wrapper>
    </SentryWrap>
    );
};

export default ParentCalenar;

